export default __webpack_public_path__ + "static/media/screenshot-3.afaabbfa.png";